module.exports = __webpack_public_path__ + "img/case01.810fb2d1.jpg";